import React from 'react';
import DirectionsRenderer from './DirectionsRenderer';

const RoutesManager = () => {
  // Coordenadas exatas fornecidas pelo usuário
  const pontoSaida = { lat: -25.452331, lng: -49.254341 };
  const ponto1 = { lat: -25.476073, lng: -49.262600 };
  const ponto2 = { lat: -25.476694, lng: -49.275646 };
  const ponto3 = { lat: -25.460128, lng: -49.276354 };

  // Definir as rotas em sequência: Saída → Ponto 1 → Ponto 2 → Ponto 3
  const routes = [
    {
      id: 'saida-ponto1',
      name: 'Saída → Ponto 1',
      origin: pontoSaida,
      destination: ponto1,
      color: '#3B82F6',
      active: true
    },
    {
      id: 'ponto1-ponto2',
      name: 'Ponto 1 → Ponto 2',
      origin: ponto1,
      destination: ponto2,
      color: '#3B82F6',
      active: true
    },
    {
      id: 'ponto2-ponto3',
      name: 'Ponto 2 → Ponto 3',
      origin: ponto2,
      destination: ponto3,
      color: '#3B82F6',
      active: true
    }
  ];

  return (
    <>
      {routes.map((route) => {
        // Só renderizar rotas ativas
        if (!route.active) return null;
        
        return (
          <DirectionsRenderer
            key={route.id}
            origin={route.origin}
            destination={route.destination}
            travelMode="DRIVING"
            strokeColor={route.color}
            strokeWeight={4}
            strokeOpacity={0.8}
          />
        );
      })}
    </>
  );
};

export default RoutesManager; 